module.exports = __webpack_public_path__ + "static/media/gal0701.e55f3103.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal07/gal0701.jpg
// module id = 510
// module chunks = 0